import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Grid, Typography } from '@material-ui/core';
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { invokePostService, setReRender, handleSnackBar, toggleRightDrawer, setFocusElement } from '../../../store/global/actions'
import { getRightDrawerStatus } from '../../../store/global/selectors';

const DeleteSimulationTestsuite = ({onClose, onCompletion, element}) => {
    
    const dispatch = useDispatch();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const currentUrl = window.location.href;
    const [slug, blueprintID] = currentUrl.split('/').slice(4);
    const drawerStatus = useSelector(getRightDrawerStatus);

    const onDelete = () => {
        setLoading(true);
        dispatch(invokePostService('deleteSimulationTestsuite', {}, [element._id]))
            .then((response) => {
                // console.log('delete resp: ', response);

                if (response.status) {
                    if(response.data.nextTestsuite != undefined){
                        const nextTestsuite =  response.data.nextTestsuite
                        if(nextTestsuite.testcase != undefined){
                            const testcase = nextTestsuite.testcase
                            history.push(`/blueprint/${slug}/${blueprintID}/testsuite/${nextTestsuite._id.toString()}?testcase=${testcase._id.toString()}`);
                        }else{
                            history.push(`/blueprint/${slug}/${blueprintID}/testsuite/${nextTestsuite._id.toString()}`);
                        }
                    }else{
                        history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
                    }

                    onClose();
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: "success" }));
                    if(drawerStatus) dispatch(toggleRightDrawer());
                    dispatch(setFocusElement({}));
                    dispatch(setReRender());
                }else {
                    // console.log("Delete error: ", response.message)
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
                }
                setLoading(false);
            })

    }


    return (
        <Grid container direction={"row"} spacing={1} >

            <Grid item xs={12}>
                <Typography> Are you sure you want to delete testsuite {element?.name ? element?.name : ''} ? </Typography>
            </Grid>
            <Grid item xs={12} style={{marginTop: '10px'}} >
                <Typography> Associated testcases will be deleted.</Typography>
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", textTransform: 'capitalize' }} >
                <DeleteCancel onCancel={onClose} onDelete={onDelete} disableButton={loading} content={loading ? 'Deleting..' : 'Delete'} />
            </Grid>


        </Grid>
    )

}

export default DeleteSimulationTestsuite;
